// DataTable.jsx — 第九十一批：数据表的唯一外壳（自带横向滚动 + 最小宽度）。
//
// ── 病灶（实测，不是猜测）────────────────────────────────────────────────────
// 需求方报「mobile 下显示错位和控件推挤」。真 Edge 在 360px 宽下实测的结论出乎意料：
// **没有一个页面横向溢出**——问题不是溢出，是 MUI 表格在压缩列宽：单元格文字折行
// 成高塔（/admin/logs 实测 800 个折行格、最高的一格 38.8 个行高；/admin 账号表七列
// 被压到最窄 46px）。滚动容器其实一直都在，**但表格没有最小宽度，容器永远不需要
// 滚**——「给表格加横向滚窗的能力」这句话的真正缺口只是一个 minWidth。
//
// ── 为什么是共享组件而不是各页自己写 sx ─────────────────────────────────────
// 修法本身只有两行（TableContainer overflowX + Table minWidth），但它要落在十来张
// 表上，而"各自写两行"正是漂移的起点：下一张新表会抄漏其中一行，然后在某个视口
// 恢复压扁——而那没有任何判据会响（本批的常驻探针只盯已迁移的表）。一个外壳组件
// 让"新表默认就有滚动能力"成为结构，而不是纪律。
//
// ── minWidth 由调用方给 ─────────────────────────────────────────────────────
// 每张表的合理最小宽度取决于列的内容（日志的 message 列与账号表的邮箱列完全不同），
// 组件猜不出来。默认 560 只是"四列窄表也别压碎"的底线。
// 取值参考：4 列 ≈ 560；5 列 ≈ 640；7 列（账号表）≈ 900。
// **平板边界（第九十一批 verify 实测）**：768px 视口的内容盒是 718px（Container px 24×2
// + Paper 边框 2）；Card/CardContent 里再少 32px ≈ 686px。一张平板上本不需要滚的表，
// minWidth 给到 720 会强出 2px 假滚动——**想在平板上免滚就 ≤700（Card 内 ≤680）**；
// 明确要滚的表（账号 900）不受此限。
import { Paper, Table, TableContainer } from '@mui/material';

export default function DataTable({ minWidth = 560, size = 'small', sx, children, ...rest }) {
  return (
    <TableContainer component={Paper} variant="outlined" sx={{ overflowX: 'auto', ...sx }}>
      <Table size={size} sx={{ minWidth }} {...rest}>
        {children}
      </Table>
    </TableContainer>
  );
}
